export function Price(price: any) {
    const priceString = parseFloat(price).toFixed(2);
    return `R$ ${priceString.replace(".", ",")}`;
}
